import { useTableV2GridContext, ViewMode } from "@/components/ui/TableV2";
import { useReportContext } from "@/components/Evaluate/report-context";
import { ReportColumn } from "@/types/evaluate";

export const useEvaluateGridContext = () => {
  const context = useTableV2GridContext();
  const report = useReportContext();
  const columns = report?.sortedColumns;

  const hideDatasetColumns = () => {
    if (!columns) {
      return;
    }

    const datasetColumns = columns.filter((col: ReportColumn) => col.column_type === "DATASET");
    const datasetColumnNames = datasetColumns.map((col: ReportColumn) => col.name);

    context.tableStore?.addHiddenColumns(datasetColumnNames);
  };

  const showAllColumns = () => {
    context.tableStore?.showAllColumns();
  };

  return {
    ...context,
    hideDatasetColumns,
    showAllColumns,
  };
};

export const useGridContext = useEvaluateGridContext;
export { ViewMode };
